export default "__VITE_ASSET__763a0ff3__"